import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, iif, Observable, of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { Action } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';

import { AbandonedReservationService } from '@abandoned-reservation/services/abandoned-reservation.service';
import * as actions from '@abandoned-reservation/store/actions/abandoned-reservation.actions';
import { AuthService } from '@app/services/auth.service';
import { UserService } from '@app/modules/core/services/user.service';
import { getReservationType } from '@user-history/mappers/user-history.mapper';
import { initHistoryDetailVmMapper, getHistoryDetailVmMapper } from '@user-history/mappers/history-detail-vm.mapper';

@Injectable()
export class AbandonedReservationEffect {

  constructor(
    private action$: Actions,
    private service: AbandonedReservationService,
    private cookieService: CookieService,
    private authService: AuthService,
    private userService: UserService,
  ) { }

  fetchUserAbandonedReservation$: Observable<Action> = createEffect(() => this.action$
    .pipe(
      ofType(actions.fetchAbandonedReservationAction),
      switchMap(() => this.service.fetchUserAbandonedReservation()
        .pipe(
          map(response => {
            const historyDetailType = getReservationType(response);
            const initDetailVm = initHistoryDetailVmMapper(response, historyDetailType, response.FreeCancelationTimeRemaining);
            return getHistoryDetailVmMapper(initDetailVm, response, historyDetailType);
          }),
          map(response =>
            actions.fetchAbandonedReservationSuccessAction({ response })),
          catchError(() => EMPTY)
        )
      )
    ));

  cancelAbandonedReservationAction$: Observable<Action> = createEffect(() => this.action$
    .pipe(
      ofType(actions.cancelAbandonedReservationAction),
      switchMap(action => {
        const token = this.authService.authToken();
        const SeamlessLoginToken = this.cookieService.get('SeamlessLogin');
        return iif(
          () => !!SeamlessLoginToken,
          of(SeamlessLoginToken),
          this.userService.seamlessLogin(token)
        ).pipe(
          take(1),
          switchMap(sessionToken => this.service.cancelReservation(action.travelItineraryId.toString(), sessionToken)),
          map(() => actions.cancelAbandonedReservationSuccessAction()),
          catchError(() => [actions.cancelAbandonedReservationErrorAction()])
        );
      })
    ));
}
